import axios from "axios";
import React, { Component } from "react";
import { Link } from "react-router-dom";
// get our fontawesome imports
import {
  faUser,
  faFolderOpen,
  faSignInAlt,
  faDatabase,
  faSearchDollar,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class AdminDashboard extends Component {
  constructor() {
    super();
    this.state = {
      msg: null,
      type: null,
      flash: false,
      alert: null,
    };
  }

  render() {
    const styles1 = {
      width: "200px",
    };
    const { creatifa } = this.state;
    return (
      <div className="bg-light">
        <div className="container-fluid pt-6 overflow-hidden">
          <div className="container my-4 py-3">
            <div className="container bg-white border rounded-4 p-3 p-sm-4">
              <h3 className="fw-bold">Menu Dashboard</h3>
              <hr />
              <div className="row row-cols-sm-4 row-cols-1">
                <div className="col my-3">
                  <div className="card bg-warning rounded-4 shadow">
                    <div className="card-body">
                      <h5 className="card-title fw-bold">
                        <FontAwesomeIcon icon={faDatabase} className="fa-fw" />
                        Pesanan
                      </h5>
                      <a href="#" className="btn btn-red float-end">
                        <FontAwesomeIcon icon={faSignInAlt} className="fa-fw" />
                        Enter
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col my-3">
                  <div className="card bg-light rounded-4 shadow">
                    <div className="card-body">
                      <h5 className="card-title fw-bold">
                        <FontAwesomeIcon
                          icon={faSearchDollar}
                          className="fa-fw"
                        />
                        SEO
                      </h5>
                      <a href="#" className="btn btn-red float-end">
                        <FontAwesomeIcon icon={faSignInAlt} className="fa-fw" />
                        Enter
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col my-3">
                  <div className="card bg-warning rounded-4 shadow">
                    <div className="card-body">
                      <h5 className="card-title fw-bold">
                        {" "}
                        <FontAwesomeIcon
                          icon={faFolderOpen}
                          className="fa-fw"
                        />
                        Content
                      </h5>
                      <a href="#" className="btn btn-red float-end">
                        <FontAwesomeIcon icon={faSignInAlt} className="fa-fw" />
                        Enter
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col my-3">
                  <div className="card bg-light rounded-4 shadow">
                    <div className="card-body">
                      <h5 className="card-title fw-bold">
                        <FontAwesomeIcon icon={faUser} className="fa-fw" />
                        Pengguna
                      </h5>
                      <a href="#" className="btn btn-red float-end">
                        <FontAwesomeIcon icon={faSignInAlt} className="fa-fw" />
                        Enter
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container my-4 py-3">
            <div className="container bg-white border rounded-4 p-3 p-sm-4">
              <h3 className="fw-bold">Queue Pesanan</h3>
              <hr />
              <div className="row">
                <div class="table-responsive">
                  <table className="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th scope="col">No</th>
                        <th scope="col">First</th>
                        <th scope="col">Last</th>
                        <th scope="col">Handle</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">1</th>
                        <td>Mark</td>
                        <td>Otto</td>
                        <td>@mdo</td>
                      </tr>
                      <tr>
                        <th scope="row">2</th>
                        <td>Jacob</td>
                        <td>Thornton</td>
                        <td>@fat</td>
                      </tr>
                      <tr>
                        <th scope="row">3</th>
                        <td>Jacob</td>
                        <td>Thornton</td>
                        <td>@fat</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AdminDashboard;
